import {
  AdminSentNotificationDto,
  SendNotificationRequest,
  SendNotificationV3Request,
  State,
} from "../../interfaces";
import { Paginated } from "../../models";
import {
  ActionTypes,
  DELETE_NOTIFICATION,
  DELETE_NOTIFICATION_ERROR,
  DELETE_NOTIFICATION_SUCCESS,
  GET_ADMIN_SENT_NOTIFICATIONS,
  GET_ADMIN_SENT_NOTIFICATIONS_ERROR,
  GET_ADMIN_SENT_NOTIFICATIONS_SUCCESS,
  RESET_SEND_NOTIFICATION,
  RESET_SEND_NOTIFICATION_V3,
  SEND_NOTIFICATION,
  SEND_NOTIFICATION_ERROR,
  SEND_NOTIFICATION_SUCCESS,
  SEND_NOTIFICATION_V3,
  SEND_NOTIFICATION_V3_ERROR,
  SEND_NOTIFICATION_V3_SUCCESS,
} from "./actionTypes";

export class NotificationState {
  sendNotification!: State<SendNotificationRequest>;
  sendNotificationV3!: State<SendNotificationV3Request>;
  adminSentNotifications!: State<Paginated<AdminSentNotificationDto>>;
  deleteNotification!: State<any>;
  constructor() {
    this.sendNotification = {
      loading: false,
      error: null,
      success: false,
    };
    this.sendNotificationV3 = {
      loading: false,
      error: null,
      success: false,
    };
    this.adminSentNotifications = {
      loading: false,
      error: null,
      success: false,
    };
    this.deleteNotification = {
      loading: false,
      error: null,
      success: false,
    };
  }
}

const initialState: NotificationState = new NotificationState();

export const notification = (
  state: NotificationState = initialState,
  action: ActionTypes
) => {
  switch (action.type) {
    case SEND_NOTIFICATION:
      state = {
        ...state,
        sendNotification: {
          ...state.sendNotification,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case SEND_NOTIFICATION_SUCCESS:
      state = {
        ...state,
        sendNotification: {
          ...state.sendNotification,
          loading: false,
          error: null,
          success: true,
        },
      };
      break;
    case SEND_NOTIFICATION_ERROR:
      state = {
        ...state,
        sendNotification: {
          ...state.sendNotification,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case RESET_SEND_NOTIFICATION:
      state = {
        ...state,
        sendNotification: {
          ...state.sendNotification,
          loading: false,
          success: false,
          error: null,
          response: undefined,
        },
      };
      break;
    case SEND_NOTIFICATION_V3:
      state = {
        ...state,
        sendNotificationV3: {
          ...state.sendNotificationV3,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case SEND_NOTIFICATION_V3_SUCCESS:
      state = {
        ...state,
        sendNotificationV3: {
          ...state.sendNotificationV3,
          loading: false,
          error: null,
          success: true,
        },
      };
      break;
    case SEND_NOTIFICATION_V3_ERROR:
      state = {
        ...state,
        sendNotificationV3: {
          ...state.sendNotificationV3,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case RESET_SEND_NOTIFICATION_V3:
      state = {
        ...state,
        sendNotificationV3: {
          ...state.sendNotificationV3,
          loading: false,
          success: false,
          error: null,
          response: undefined,
        },
      };
      break;
    case GET_ADMIN_SENT_NOTIFICATIONS:
      state = {
        ...state,
        adminSentNotifications: {
          ...state.adminSentNotifications,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case GET_ADMIN_SENT_NOTIFICATIONS_SUCCESS:
      state = {
        ...state,
        adminSentNotifications: {
          ...state.adminSentNotifications,
          loading: false,
          error: null,
          success: true,
          response: action.payload,
        },
      };
      break;
    case GET_ADMIN_SENT_NOTIFICATIONS_ERROR:
      state = {
        ...state,
        adminSentNotifications: {
          ...state.adminSentNotifications,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case DELETE_NOTIFICATION:
      state = {
        ...state,
        deleteNotification: {
          ...state.deleteNotification,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case DELETE_NOTIFICATION_SUCCESS:
      state = {
        ...state,
        deleteNotification: {
          ...state.deleteNotification,
          loading: false,
          error: null,
          success: true,
        },
      };
      break;
    case DELETE_NOTIFICATION_ERROR:
      state = {
        ...state,
        deleteNotification: {
          ...state.deleteNotification,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};
